import type { ComponentType } from 'react';

import { SaleType } from '@sorare/core/src/lib/algolia';
import { CardsShow } from '@sorare/marketplace/src/components/market-home/CardsShow';
import { useHits } from '@sorare/marketplace/src/hooks/search/useSortedItems';
import type { CardResultsProps } from '@sorare/marketplace/src/searchCards/AdvancedCardSearch/types';

export const CardsShowWithHits: ComponentType<CardResultsProps> = props => {
  const { sport } = props;
  const { loading, hits } = useHits({
    sport,
    stackableTypes: [SaleType.PRIMARY_OFFER],
  });
  return <CardsShow {...props} hits={hits} loading={loading} />;
};
